import { useCallback } from "react";
import styled from "styled-components";
import { _ } from "@sablier/v2-mixins";
import numeral from "numeral";

const WrapperPartial = styled.li`
  ${(props) => props.theme.styles.row}
  & {
    justify-content: center;
    width: 100%;
    padding: calc(${(props) => props.theme.sizes.edge} * 1 / 2) 0;
    background-color: ${(props) => props.theme.colors.transparent};
    list-style-type: none;
    cursor: pointer;
  }
`;

const Title = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 4px;

    & > p {
      ${(props) => props.theme.styles.textParagraphMini}
      & {
        color: ${(props) => props.theme.colors.gray100};
        font-weight: 600;
        text-align: center;
      }
    }
  }
`;

const Wrapper = styled(WrapperPartial)`
  &[data-selected="true"] {
    cursor: default;
    ${Title} {
      background-color: ${(props) => props.theme.colors.secondaryMiddle};
      & > p {
        color: ${(props) => props.theme.colors.white};
      }
    }
  }
  &:not([data-selected="true"]) {
    &:hover {
      background-color: ${(props) => props.theme.colors.dark400};
    }
  }

  ${(props) => props.theme.medias.maxSM} {
    padding: calc(${(props) => props.theme.sizes.edge} * 1 / 4) 0;
  }
`;

interface Props {
  value: number;
  onClick: (value: number) => void;
  isSelected?: boolean;
}

function Item({ onClick: _onClick, isSelected = false, value }: Props) {
  const onClick = useCallback(() => {
    _onClick(value);
  }, [value, _onClick]);

  return (
    <Wrapper data-selected={isSelected} onClick={onClick}>
      <Title>
        <p>{numeral(value).format("00")}</p>
      </Title>
    </Wrapper>
  );
}

export default Item;
